package com.tixforgigs.common.ui.components.templateConfigurator


import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.ui.components.forms.outlinedSelect
import com.tixforgigs.common.ui.components.mandarin.mandarinHeadline
import com.tixforgigs.apax.models.FontVariable
import io.kvision.core.Container
import io.kvision.html.fieldset
import io.kvision.html.span
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

fun Container.fontOptions(
  state: MutableStateFlow<List<FontVariable>>
) {
  @MissingTaramiMessageKey
  mandarinHeadline(subheadline = "Fonts")

  fieldset(className = "xm-inputs").bind(state) { list ->
    list.forEach { item ->
      simplePanel(className = "xm-font-chooser") {
        outlinedSelect(
          label = item.variable.name,
          items = CustomFont.entries,
          itemLabel = { it.value },
          initialSelectedItemIndex = { availableFonts ->
            availableFonts.indexOfFirst { it.value == item.font }
          },
          onSelected = { font ->
            state.update { stateList ->
              stateList.map { stateItem ->
                if (stateItem.variable == item.variable) {
                  stateItem.copy(font = font.value)
                } else stateItem
              }
            }
          }
        )
      }
    }
    if (list.isEmpty()) {
      @MissingTaramiMessageKey
      span { +"aktuell kannst du keine Schriftarten bearbeiten" }
    }
  }

}

//TODO needed from server
enum class CustomFont(val value: String) {

  ROBOTO("Roboto"),
  RUBIK("Rubik Distressed"),
  BALLET("Ballet"),
  FRAKTUR("Unifraktur"),
  MARKER("Permanent Marker"),
  BODONI("Bodoni Moda SC"),
  OPTS("OPTS");

  companion object {

    private val map = entries.associateBy { it.value }
    infix fun from(value: String) = map[value]
  }
}
